/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCompanyMemberResource
 */
export interface ClientCompanyMemberResource {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyMemberResource
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyMemberResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyMemberResource
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyMemberResource
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyMemberResource
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyMemberResource
     */
    photoUrl?: string;
}

/**
 * Check if a given object implements the ClientCompanyMemberResource interface.
 */
export function instanceOfClientCompanyMemberResource(value: object): value is ClientCompanyMemberResource {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ClientCompanyMemberResourceFromJSON(json: any): ClientCompanyMemberResource {
    return ClientCompanyMemberResourceFromJSONTyped(json, false);
}

export function ClientCompanyMemberResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyMemberResource {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'identityId': json['identityId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
    };
}

export function ClientCompanyMemberResourceToJSON(value?: ClientCompanyMemberResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'identityId': value['identityId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'photoUrl': value['photoUrl'],
    };
}

